







































































export default {
  name: "TableDynamicSimpel",
  components: {},
  props: {
    items: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      default: null
    },
    primaryKey: {
      type: String,
      default: null
    },
    secondaryKey: {
      type: String,
      default: null
    },
    sortBy: {
      type: String,
      default: null
    },
    sortDesc: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dSortBy: this.sortBy,
      dSortDesc: this.sortDesc
    };
  },
  computed: {
    cFields() {
      if (this.items.isEmpty()) {
        return [];
      }

      if (!this.fields) {
        return Object.keys(this.items[0]).map(item => {
          return {
            key: item
          };
        });
      }

      return [...this.fields].sort((a, b) => {
        if (!a.order || !b.order) {
          return 0;
        }

        if (a.order < b.order) {
          return -1;
        }

        if (a.order > b.order) {
          return 1;
        }

        return 0;
      });
    },
    sortedItems(): any[] {
      if (!this.dSortBy) {
        return this.items;
      }

      return this.items.slice().sort((a, b) => {
        const aElement = a[this.dSortBy];
        const bElement = b[this.dSortBy];

        if (aElement === null) {
          return 1;
        }

        if (bElement === null) {
          return -1;
        }

        if (aElement === bElement) {
          return 0;
        }

        if (!this.dSortDesc) {
          return aElement < bElement ? -1 : 1;
        }

        if (this.dSortDesc) {
          return aElement < bElement ? 1 : -1;
        }

        return 0;
      });
    }
  },
  methods: {
    getRowKey(item) {
      if (!this.secondaryKey) {
        return item[this.primaryKey];
      }

      if (!item[this.secondaryKey]) {
        return item[this.primaryKey];
      }

      return `${item[this.primaryKey]}-${item[this.secondaryKey]}`;
    },
    label(field) {
      return field.label === undefined ? field.key : field.label;
    },
    sort(key) {
      if (this.dSortBy !== key) {
        this.dSortBy = key;
        return;
      }

      this.dSortDesc = !this.dSortDesc;
    },
    row(item, key) {
      return {
        item,
        value: item[key]
      };
    }
  }
};
